module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.ac8d04b.ttf";